import { useEffect, useState } from "react";
import { buscarAnuncioPropriedeByCotaUsuario } from "../../../services/buscarAnuncioPropriedeByCotaUsuarioService";

export const useAnuncioPropriedade = (cotaUsuarioId: number | null) => {
  const [anuncioPropriedade, setAnuncioPropriedade] = useState<any | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetch = async () => {
      if (cotaUsuarioId) {
        setLoading(true);
        try {
          const data = await buscarAnuncioPropriedeByCotaUsuario(cotaUsuarioId);
          if (data) {
            setAnuncioPropriedade(data[0]);
          }
        } catch (err) {
          console.error("Erro ao buscar anuncio propriedade:", err);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetch();
  }, [cotaUsuarioId]);

  return { anuncioPropriedade, loading };
};
